export const ORDER_TYPES = {
    DELIVERY: 'delivery',
    SELF_PICKUP: 'self-pickup',
    DINE_IN: 'dine-in',
};

const ORDER_TYPE_ALIASES = {
    'delivery': ORDER_TYPES.DELIVERY,
    'deliverybycourier': ORDER_TYPES.DELIVERY,
    'delivery by courier': ORDER_TYPES.DELIVERY,
    'courier': ORDER_TYPES.DELIVERY,
    'fast delivery': ORDER_TYPES.DELIVERY,
    'self-pickup': ORDER_TYPES.SELF_PICKUP,
    'self pickup': ORDER_TYPES.SELF_PICKUP,
    'selfpickup': ORDER_TYPES.SELF_PICKUP,
    'pickup': ORDER_TYPES.SELF_PICKUP,
    'take-away': ORDER_TYPES.SELF_PICKUP,
    'take away': ORDER_TYPES.SELF_PICKUP,
    'takeaway': ORDER_TYPES.SELF_PICKUP,
    'deliverybyclient': ORDER_TYPES.SELF_PICKUP,
    'delivery by client': ORDER_TYPES.SELF_PICKUP,
    'self-service': ORDER_TYPES.SELF_PICKUP,
    'dine-in': ORDER_TYPES.DINE_IN,
    'dine in': ORDER_TYPES.DINE_IN,
    'dinein': ORDER_TYPES.DINE_IN,
    'table': ORDER_TYPES.DINE_IN,
    'at the table': ORDER_TYPES.DINE_IN,
    'common': ORDER_TYPES.DINE_IN,
};

export const ORDER_TYPE_ICONS = {
    [ORDER_TYPES.DELIVERY]: '🚚',
    [ORDER_TYPES.SELF_PICKUP]: '🏃',
    [ORDER_TYPES.DINE_IN]: '🍽',
};

const DEFAULT_LABELS = {
    [ORDER_TYPES.DELIVERY]: 'Delivery',
    [ORDER_TYPES.SELF_PICKUP]: 'Self Pickup',
    [ORDER_TYPES.DINE_IN]: 'At the Table',
};

const DEFAULT_HINTS = {
    [ORDER_TYPES.DELIVERY]: 'We deliver it to you',
    [ORDER_TYPES.SELF_PICKUP]: 'You pick it up yourself',
    [ORDER_TYPES.DINE_IN]: 'Served at your table',
};

const STAFF_LABELS = {
    [ORDER_TYPES.DELIVERY]: 'DELIVERY',
    [ORDER_TYPES.SELF_PICKUP]: 'SELF PICKUP',
    [ORDER_TYPES.DINE_IN]: 'DINE IN',
};

const STAFF_HINTS = {
    [ORDER_TYPES.DELIVERY]: 'courier delivers to the customer',
    [ORDER_TYPES.SELF_PICKUP]: 'customer picks it up themselves',
    [ORDER_TYPES.DINE_IN]: 'served at the table',
};

export const normalizeOrderType = (value) => {
    if (typeof value !== 'string') return null;
    const key = value.trim().toLowerCase().replace(/\s+/g, ' ');
    if (!key) return null;
    return ORDER_TYPE_ALIASES[key] || null;
};

export const resolveOrderType = (...candidates) => {
    for (const candidate of candidates) {
        const canonical = normalizeOrderType(candidate);
        if (canonical) return canonical;
    }
    for (const candidate of candidates) {
        if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
    }
    return null;
};

export const getOrderTypeIcon = (value) => ORDER_TYPE_ICONS[normalizeOrderType(value)] || '📋';

export const getOrderTypeLabel = (value, translations) => {
    const canonical = normalizeOrderType(value);
    if (!canonical) return '';
    const page = translations?.deliveryPage || {};
    const localized = {
        [ORDER_TYPES.DELIVERY]: page.delivery,
        [ORDER_TYPES.SELF_PICKUP]: page.SelfInPickup,
        [ORDER_TYPES.DINE_IN]: page.AtTheTable,
    }[canonical];
    return localized || DEFAULT_LABELS[canonical];
};

export const getOrderTypeHint = (value, translations) => {
    const canonical = normalizeOrderType(value);
    if (!canonical) return '';
    const page = translations?.deliveryPage || {};
    const localized = {
        [ORDER_TYPES.DELIVERY]: page.deliveredToYou,
        [ORDER_TYPES.SELF_PICKUP]: page.collectedByYou,
        [ORDER_TYPES.DINE_IN]: page.servedAtTable,
    }[canonical];
    return localized || DEFAULT_HINTS[canonical];
};

export const getOrderTypeStaffSummary = (value) => {
    const canonical = normalizeOrderType(value);
    if (!canonical) return null;
    return {
        canonical,
        icon: ORDER_TYPE_ICONS[canonical],
        label: STAFF_LABELS[canonical],
        hint: STAFF_HINTS[canonical],
    };
};

export const formatOrderTypeForAdmin = (value, translations) => {
    const canonical = normalizeOrderType(value);
    if (canonical) {
        return `${ORDER_TYPE_ICONS[canonical]} ${getOrderTypeLabel(canonical, translations)}`;
    }
    if (typeof value === 'string' && value.trim()) return value.trim();
    return '—';
};
